// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUnlockMfaDto
 */
export interface IUnlockMfaDto {
    /**
     * 
     * @type {number}
     * @memberof IUnlockMfaDto
     */
    employee_id: number;
}

/**
 * Check if a given object implements the IUnlockMfaDto interface.
 */
export function instanceOfIUnlockMfaDto(value: object): value is IUnlockMfaDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IUnlockMfaDtoFromJSON(json: any): IUnlockMfaDto {
    return IUnlockMfaDtoFromJSONTyped(json, false);
}

export function IUnlockMfaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUnlockMfaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
    };
}

export function IUnlockMfaDtoToJSON(json: any): IUnlockMfaDto {
    return IUnlockMfaDtoToJSONTyped(json, false);
}

export function IUnlockMfaDtoToJSONTyped(value?: IUnlockMfaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
    };
}

